/* eslint-disable @angular-eslint/prefer-standalone */
import { Component, EventEmitter, Injector, Output } from '@angular/core';
import * as moment from 'moment';
import { BaseCustomFields } from '../base-custom-fields';

@Component({
  selector: 'tgv-custom-fields-form',
  standalone: false,
  templateUrl: './custom-fields-form.component.html'
})
export class CustomFieldsFormComponent extends BaseCustomFields {
  @Output() resourceComplements = new EventEmitter();

  constructor(protected override injector: Injector) {
    super(injector);
  }

  setPresentationFields(): void {
    this.fields.forEach(f => {
      if (f.type == 'Date') {
        if (this.fieldsValues[f.property]) {
          this.fieldsValues[f.property] = this.formatFilterDate(this.fieldsValues[f.property]);
        }
      }
    });
  }

  formatFilterDate(date: string): string {
    const newDate = this.datePipe.transform(date, 'dd/MM/yyyy');
    const dateFormat = moment(newDate, 'DD/MM/YYYY');
    return dateFormat.format('YYYY-MM-DD');
  }

  onChangesValidate(): void {
    this.resourceComplements.emit();
  }

}
